import { Injectable, Inject, Optional } from '@angular/core';

@Injectable()
export class AdminshareService {

  from_page:string="";
  temp_send_list :any=[];
  search_item: any = null;
  set_question_category:any = {
    event_id:0,
    temp_selected_list:[]
  };
  set_edit_event:any=null;
  accceptSetting:any = {
    "reloadFlg":false,
    "soundFlg":false,
    "countDownId":0
  }

  constructor(
  ) { }
  /** 予約受付設定情報 */
  setaccceptSetting(accceptSetting: any): void {
    //リクエストパラメータセット
    this.accceptSetting = accceptSetting;
  }
  /** 予約受付設定情報取得 */
  getaccceptSetting(): any {
      return this.accceptSetting;
  }
}



// WEBPACK FOOTER //
// ./src/app/service/adminshare.service.ts